//@flow
import _ from 'lodash';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import { withRouter } from 'react-router-dom';
import FullCustomCard from '../../../components/FullCustomCard/FullCustomCard';
import TopoTitleComponente from '../../../components/PageTitle/TopoTitleComponente';
import TopoListagem from '../../../components/Topo/TopoListagem';
import { objectsConstants } from '../../../_constants/objects.constants';
import { saidaEstoqueService } from '../../../_services/saidaEstoque.service';
import EstoqueSaidaForm from './EstoqueSaidaForm';
import { dateHelper } from '../../../_helpers/date.helper';

// const defaultArrayItem = [{ idList: new Date().getTime() }];

class EstoqueSaidaView extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {
      entity: { status: true },
    };
  }

  componentDidMount() {
    this.loadSaidaEstoque();
  }

  loadSaidaEstoque = () => {
    if (this.props.match.params.id) {
      this.props.loading(true);
      saidaEstoqueService.doGet(this.props.match.params.id).then(
        (response) => {
          let saidaEstoque = response.data.data;
          let horaLancamento = _.get(saidaEstoque, `dataHoraLancamento`)
            ? dateHelper.getHourFormat(
                _.get(saidaEstoque, `dataHoraLancamento`),
                {
                  mode: 'TIME',
                }
              )
            : '--';
          _.set(saidaEstoque, 'horaLancamento', horaLancamento);
          this.setState({ entity: saidaEstoque }, () => {
            this.props.loading(false);
          });
        },
        (error) => {
          console.log(error);
          this.props.loading(false);
        }
      );
    }
  };
  handleCancel = () => {
    this.props.history.goBack();
  };

  handleDeleteItem = (index, entity) => {
    this.props.loading(true);
    saidaEstoqueService.doDelete(entity.id).then(
      (response) => {
        this.props.success({
          message: `Saida foi excluído com sucesso!`,
        });
        this.props.loading(false);
        this.props.history.push('/estoque-saida');
      },
      (error) => {
        console.log(error);
        this.props.loading(false);
        this.props.error({
          message: 'Não foi possível excluir Saida.',
        });
      }
    );
  };

  handleChangeProfile = (name, value) => {
    // let validateModel = this.ObjectValidateProfile(value);
    const entity = _.cloneDeep(this.state.entity);
    _.set(entity, name, value);
    this.setState({ entity });
  };

  handleChange = (name, value) => {
    const entity = _.cloneDeep(this.refFormComponent.state.values);
    _.set(entity, name, value);
    this.setState({ entity });
  };

  handleSubmit = (e) => {
    this.refFormComponent
      .validateForm(this.refFormComponent.values)
      .then((erros) => {
        console.log(erros);
        if (_.isEmpty(erros)) {
          this.refFormComponent.handleSubmit();
        }
      });
  };

  render() {
    const { entity } = this.state;
    const { ...otherPops } = this.props;
    return (
      <React.Fragment>
        {/* <div className="d-flex flex-column flex-xl-row justify-content-center"> */}
        {entity.id && (
          <React.Fragment>
            <TopoTitleComponente
              mainTitle={`${entity.id ? 'Editar ' : 'Nova '}  saída`}
              canBack={true}
              backUrl={!entity.id ? null : '/estoque-saida'}
            />
            <TopoListagem
              showIndisponibilidade={false}
              showfilter={false}
            ></TopoListagem>
            <div className="flex-column">
              <FullCustomCard
                permissionSave={objectsConstants.MENU_ESTOQUE}
                ref={(form) => {
                  this.refFormComponent = form;
                }}
                title="Usuário"
                Componente={EstoqueSaidaForm}
                viewMode={true}
                entity={entity}
                // cancelForm={this.loadUser}
                // onSave={this.loadUser}
                btnExcluir={false}
                // removeItem={this.handleDeleteItem}
                redirectPath="/estoque-saida/view/"
                {...otherPops}
              ></FullCustomCard>
            </div>
            {<div className="flex-column"></div>}
          </React.Fragment>
        )}
        {/* </div> */}
      </React.Fragment>
    );
  }
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(null, mapDispatch, null)(withRouter(EstoqueSaidaView));
